import React from "react"

import { Gallery } from "components"

const GalleryBlock = ({ images }) => <Gallery images={images} />

export default GalleryBlock
